import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useParams, Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faArrowLeft,
  faProjectDiagram,
  faCalendarAlt,
  faGlobe,
  faUser,
  faUsers,
  faCommentDots,
  faStar
} from '@fortawesome/free-solid-svg-icons';
const token = localStorage.getItem('token');

const ProjectDetail = () => {
  const { id } = useParams();
  const [project, setProject] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);


  useEffect(() => {
    const fetchProject = async () => {
      setLoading(true);
      setError(null);
      try {
        const res = await axios.get(`/project/${id}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setProject(res.data);
      } catch (err) {
        setError('Erreur lors du chargement du projet.');
      } finally {
        setLoading(false);
      }
    };

    fetchProject();
  }, [id]);

  if (loading) return <p>Chargement du projet...</p>;
  if (error) return <p className="text-red-600">{error}</p>;
  if (!project) return <p>Projet non trouvé.</p>;
const imagePath = project.imageUrl ? project.imageUrl.replace(/\\/g, '/') : '';
  return (
    <div className="project-detail-container">
      {/* Header Section */}
      <div className="project-header">
        <div className="header-content">
          <div className="breadcrumb">
            <Link to="/admin/projects" className="back-button">
              <FontAwesomeIcon icon={faArrowLeft} />
              <span>Retour à la liste</span>
            </Link>
          </div>
          <h1 className="project-title">
            <FontAwesomeIcon icon={faProjectDiagram} className="title-icon" />
            {project.projectName}
          </h1>
        </div>
      </div>

      <div className="project-content">
        {/* Project Image */}
        {project.imageUrl && (
          <div className="project-image-section">
            <div className="image-container">
<img
  src={`/uploads/${imagePath}`}
  alt="Image du projet"
  onError={(e) => {
    e.currentTarget.onerror = null;
    e.currentTarget.src = '/defaults/defaultPartnerLogo.png';
  }}
  className="project-image"
/>


            </div>
          </div>
        )}

        {/* Main Information */}
        <div className="project-info-grid">
          <div className="info-card main-info">
            <h3 className="card-title">
              <FontAwesomeIcon icon={faProjectDiagram} />
              À propos du projet
            </h3>
            <p className="project-description">{project.about}</p>
            
            <div className="project-details">
              <div className="detail-item">
                <FontAwesomeIcon icon={faCalendarAlt} className="detail-icon" />
                <div className="detail-content">
                  <span className="detail-label">Période</span>
                  <span className="detail-value">{project.startDate} - {project.endDate}</span>
                </div>
              </div>

              <div className="detail-item">
                <FontAwesomeIcon icon={faProjectDiagram} className="detail-icon" />
                <div className="detail-content">
                  <span className="detail-label">Type de service</span>
                  <span className="detail-value">{project.serviceType}</span>
                </div>
              </div>

              {project.websiteLink && (
                <div className="detail-item">
                  <FontAwesomeIcon icon={faGlobe} className="detail-icon" />
                  <div className="detail-content">
                    <span className="detail-label">Site Web</span>
                    <a href={project.websiteLink} target="_blank" rel="noopener noreferrer" className="website-link">
                      {project.websiteLink}
                    </a>
                  </div>
                </div>
              )}

              {project.client && (
                <div className="detail-item">
                  <FontAwesomeIcon icon={faUser} className="detail-icon" />
                  <div className="detail-content">
                    <span className="detail-label">Client</span>
                    <span className="detail-value">{project.client.name} ({project.client.email})</span>
                  </div>
                </div>
              )}
            </div>
          </div>

          {/* Collaborators */}
          <div className="info-card collaborators-card">
            <h3 className="card-title">
              <FontAwesomeIcon icon={faUsers} />
              Collaborateurs
            </h3>
            {project.collaborators.length > 0 ? (
              <div className="collaborators-list">
                {project.collaborators.map((col) => (
                  <div key={col.id} className="collaborator-item">
                    <div className="collaborator-avatar">
                      <FontAwesomeIcon icon={faUser} />
                    </div>
                    <div className="collaborator-info">
                      <span className="collaborator-name">{col.name}</span>
                      <span className="collaborator-email">{col.email}</span>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <p className="no-data">Aucun collaborateur assigné</p>
            )}
          </div>
        </div>

        {/* Feedbacks */}
        {project.feedbacks && project.feedbacks.length > 0 && (
          <div className="feedbacks-section">
            <h3 className="section-title">
              <FontAwesomeIcon icon={faCommentDots} />
              Feedbacks du client
            </h3>
            <div className="feedbacks-grid">
              {project.feedbacks.map((fb) => (
                <div key={fb.id} className="feedback-card">
                  <div className="feedback-header">
                    <div className="feedback-rating">
                      <span className="rating-text">({fb.rating}/5)</span>
                    </div>
                    <div className="feedback-date">
                      <FontAwesomeIcon icon={faCalendarAlt} />
                      {new Date(fb.createdAt).toLocaleDateString('fr-FR')}
                    </div>
                  </div>
                  <div className="feedback-content">
                    <p>{fb.comment}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>

      
    </div>
  );
};

export default ProjectDetail;
